import React from "react";

interface GlobalLoadingIndicatorProps {
  isLoading?: boolean;
}

export const GlobalLoadingIndicator: React.FC<GlobalLoadingIndicatorProps> = ({
  isLoading,
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50 dark:bg-gray-900 dark:bg-opacity-50">
      <div className="flex flex-col items-center rounded-lg bg-white p-4 shadow-lg dark:bg-gray-800">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900 dark:border-gray-200"></div>
        <span className="mt-2 text-gray-700 dark:text-gray-200">
          Loading...
        </span>
      </div>
    </div>
  );
};

// Create a simple loading state management
let loadingCount = 0;
const subscribers = new Set<(isLoading: boolean) => void>();

export const useGlobalLoading = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const subscriber = (loading: boolean) => setIsLoading(loading);
    subscribers.add(subscriber);
    return () => {
      subscribers.delete(subscriber);
    };
  }, []);

  return isLoading;
};

export const showGlobalLoading = () => {
  loadingCount++;
  notifySubscribers();
};

export const hideGlobalLoading = () => {
  loadingCount = Math.max(0, loadingCount - 1);
  notifySubscribers();
};

const notifySubscribers = () => {
  const isLoading = loadingCount > 0;
  subscribers.forEach((subscriber) => subscriber(isLoading));
};
